import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import * as XLSX from "xlsx";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";
export enum BloodGroupTypes {
  'A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'
}
@Component({
  selector: 'app-blood-group-report',
  templateUrl: './blood-group-report.component.html',
  styleUrls: ['./blood-group-report.component.scss']
})
export class BloodGroupReportComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  selectedBloodGroup: any | null = null;

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['childName', 'childCode', 'gender', 'age', 'bloodGroup', 'parentsName', 'centreName', 'hospital',];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  fileName = 'Blood_Group_Report.xlsx';

  centres$: Observable<Centre[]>;


  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
  searchTerm: string = '';
  startDate: Date | null = null
  endDate: Date | null = null
  selectedCentreCode: any | null
  mData:any[]=[]
  bloodGroupTypes =['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
  constructor(private mFirestore: AngularFirestore,
              private mCentreService: CentreService,
              private readonly financialYearService: FinancialYearService) {
    this.centres$ = this.mCentreService.getAllCentres();
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
  }
  onCentreSelect(selectedCentre: Centre) {
    if (!selectedCentre) return;

    console.log("Selected Centre:", selectedCentre);

    this.selectedCentre = selectedCentre;

    this.selectedCentreCode = selectedCentre.centreCode;



    // // 1️⃣ Set centre details in form
    // this.studentForm.patchValue({
    //   centreName: selectedCentre.centreName,
    //   centreCode: selectedCentre.centreCode
    // });
  }

  private getParentsNames(guardians: any[]): string {
    if (guardians && guardians.length > 0) {
      return guardians.map(guardian => `${guardian.firstName} ${guardian.lastName}`).join(', ');
    }
    return 'N/A';
  }

  search() {
    console.log(this.startDate)
    console.log(this.endDate)
    console.log(this.selectedCentreCode)
    if (this.startDate == null && this.endDate == null && this.selectedCentreCode == null) {
      console.log('in 1')
      this.mFirestore.collection(this.env.child).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        // const filteredChildren = children
        //   .filter(child => child.bloodGroup);
        // console.log(children)
        this.dataSource.data = children.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          age: child.age, // Replace with the actual field name for age
          bloodGroup: child.bloodGroup,
          hospital: child.hospital, // Replace with the actual field name for hospital
          centreName: child.centreName,
          parentsName: this.getParentsNames(child.guardians),
          gender: child.gender,
          childCode: child.childCode

        }));

        // console.log(this.dataSource.data)
        this.dataSource.paginator = this.paginator
      })
    } else if (this.selectedCentreCode == null && this.startDate != null && this.endDate != null) {
      console.log('in 2')
      this.mFirestore.collection(this.env.child,
        ref => ref.where('dateOfAdmission',
          '>=', this.startDate)
          .where('dateOfAdmission', '<=', this.endDate)
      ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        // const filteredChildren = children
        //   .filter(child => child.bloodGroup);
        // console.log(children)
        this.dataSource.data = children.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          age: child.age, // Replace with the actual field name for age
          bloodGroup: child.bloodGroup,
          hospital: child.hospital, // Replace with the actual field name for hospital
          centreName: child.centreName,
          parentsName: this.getParentsNames(child.guardians),
          gender: child.gender,
          childCode: child.childCode

        }));
        // console.log(this.dataSource.data)
        this.dataSource.paginator = this.paginator


      })
    } else if (this.startDate != null && this.endDate != null && (this.selectedCentreCode != null || this)) {
      console.log(this.startDate)
      console.log(this.endDate)
      console.log(this.selectedCentreCode)
      console.log('in 3')
      this.mFirestore.collection(this.env.child,
        ref => ref.where('centreCode', '==', this.selectedCentreCode)
          .where('dateOfAdmission', '>=', this.startDate)
          .where('dateOfAdmission', '<=', this.endDate)
      ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        // const filteredChildren = children
        //   .filter(child => child.bloodGroup);
        // console.log(children)
        this.dataSource.data = children.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          age: child.age, // Replace with the actual field name for age
          bloodGroup: child.bloodGroup,
          hospital: child.hospital, // Replace with the actual field name for hospital
          centreName: child.centreName,
          parentsName: this.getParentsNames(child.guardians),
          gender: child.gender,
          childCode: child.childCode

        }));
        // console.log(this.dataSource.data)
        this.dataSource.paginator = this.paginator


      })
    } else if (this.startDate == null && this.endDate == null && this.selectedCentreCode != null) {
      console.log(this.startDate)
      console.log(this.endDate)
      console.log(this.selectedCentreCode)
      console.log('in 3')
      this.mFirestore.collection(this.env.child,
        ref => ref.where('centreCode', '==', this.selectedCentreCode)
      ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        // const filteredChildren = children
        //   .filter(child => child.bloodGroup);
        // console.log(children)
        this.dataSource.data = children.map(child => ({
          childName: `${child.firstName} ${child.lastName}`,
          age: child.age, // Replace with the actual field name for age
          bloodGroup: child.bloodGroup,
          hospital: child.hospital, // Replace with the actual field name for hospital
          centreName: child.centreName,
          parentsName: this.getParentsNames(child.guardians),
          gender: child.gender,
          childCode: child.childCode

        }));
        // console.log(this.dataSource.data)
        this.dataSource.paginator = this.paginator


      })
    }
  }

  search2() {
    this.dataSource.data = []
    console.log(this.startDate)
    console.log(this.endDate)
    console.log(this.selectedCentreCode)
    this.mFirestore.collection(this.env.child).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
      console.log('loading')

      let data = []
      data = children
      if (this.startDate != null && this.endDate != null) {
        data = data.filter(x => x.dateOfAdmission.toDate() >= this.startDate!! && x.dateOfAdmission.toDate() <= this.endDate!!)
        console.log(`date ${data.length}`)
      }

      if (this.selectedCentreCode != null && this.selectedCentreCode != 'All') {
        data = data.filter(x => x.centreCode == this.selectedCentreCode)
        console.log(`date ${data.length}`)

      }
this.mData =data
      this.dataSource.data = data.map(child => ({
        childName: `${child.firstName} ${child.lastName}`,
        age: child.age, // Replace with the actual field name for age
        bloodGroup: child.bloodGroup,
        hospital: child.hospital, // Replace with the actual field name for hospital
        centreName: child.centreName,
        parentsName: this.getParentsNames(child.guardians),
        gender: child.gender,
        childCode: child.childCode

      }));

      // console.log(this.dataSource.data)
      this.dataSource.paginator = this.paginator
    })

  }


  OnCentreChange($event: MatSelectChange) {
    this.selectedCentreCode = $event.value;

    this.mFirestore.collection(this.env.child).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
      const filteredChildren = children.filter(child => child.centreCode === this.selectedCentreCode);

      this.dataSource.data = filteredChildren.map(child => ({
        childName: `${child.firstName} ${child.lastName}`,
        childCode: child.childCode, // Replace with the actual field name for child code
        gender: child.gender,
        age: child.age,
        bloodGroup: child.bloodGroup,
        parentsName: this.getParentsNames(child.guardians),
        hospital: child.hospital,
        centreName: child.centreName
      }));

      this.dataSource.paginator = this.paginator;
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
onGroupSelecte(event: MatSelectChange){
 this.dataSource.filter = this.selectedBloodGroup.trim().toLowerCase();
  if(this.selectedBloodGroup !=null && this.selectedBloodGroup!= 'All'){this.dataSource.data =this.mData}
}
  exportexcel() {

    /* assessment-table id is passed over here */
    let element = document.getElementById('excel-table');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};

    /* O1 is your Column in Excel*/

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);


  }

  // Clear() {
  //   this.selectedCentreCode = null
  //   this.selectedCentre=null
  //   this.startDate = null
  //   this.endDate = null
  // }


  Clear() {
    this.selectedCentreCode = null;
    this.selectedCentre = null;

    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;

    this.selectedBloodGroup = null;

    this.mData = [];
    this.dataSource.data = [];
  }


  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;

}
